<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Webshop termékek és kategóriák</ion-title>
    <ion-buttons slot="end">
      <ion-button routerLink="/webshop-admin" fill="clear">
        <ion-icon slot="start" name="color-wand-outline"></ion-icon>
        Oldalak
      </ion-button>
      <ion-button [href]="previewUrl" target="_blank" fill="clear">
        <ion-icon slot="start" name="open-outline"></ion-icon>
        Előnézet
      </ion-button>
      <ion-button color="success" (click)="saveCurrentTab()" [disabled]="saving || loading">
        <ion-icon slot="start" name="save-outline"></ion-icon>
        Mentés
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="webshop-catalog-admin">
  <section class="hero">
    <div>
      <p class="eyebrow">WEBSHOP alrendszer</p>
      <h1>Termék- és kategóriakezelő</h1>
      <p>
        Itt szerkeszthetők a publikus webshopban megjelenő kategóriák, termékek, árak,
        készletadatok és termék-kategória kapcsolatok.
      </p>
    </div>
    <ion-icon name="storefront-outline"></ion-icon>
  </section>

  <ion-card class="workspace-card">
    <ion-card-header>
      <div class="workspace-head">
        <div>
          <ion-card-title>Katalógus szerkesztő</ion-card-title>
          <ion-card-subtitle>{{ tenantCode }} tenant termékei</ion-card-subtitle>
        </div>
        <ion-segment [(ngModel)]="tab" mode="ios">
          <ion-segment-button value="products">
            <ion-label>Termékek</ion-label>
          </ion-segment-button>
          <ion-segment-button value="categories">
            <ion-label>Kategóriák</ion-label>
          </ion-segment-button>
          <ion-segment-button value="coupons">
            <ion-label>Kuponok</ion-label>
          </ion-segment-button>
        </ion-segment>
      </div>
    </ion-card-header>

    <ion-card-content>
      <ion-spinner *ngIf="loading"></ion-spinner>
      <ion-text color="danger" *ngIf="error">{{ error }}</ion-text>

      <div class="catalog-layout" *ngIf="!loading && !error">
        <aside class="entity-list">
          <ion-searchbar
            [(ngModel)]="search"
            placeholder="Keresés név, cikkszám vagy leírás alapján"
            debounce="150"
          ></ion-searchbar>

          <ng-container *ngIf="tab === 'products'">
            <div class="list-header">
              <span>Termékek</span>
              <ion-badge color="light">{{ products.length }}</ion-badge>
            </div>

            <button
              type="button"
              class="entity-button"
              *ngFor="let product of filteredProducts"
              [class.active]="productKey(product) === selectedProductKey"
              (click)="selectedProductKey = productKey(product)"
            >
              <span>
                <strong>{{ product.name }}</strong>
                <small>{{ product.cikkszam || 'Nincs cikkszám' }} · {{ product.normal_price | number:'1.0-0' }} Ft</small>
              </span>
              <ion-badge color="medium">{{ product.categories.length }}</ion-badge>
            </button>

            <ion-button expand="block" color="tertiary" (click)="addProduct()">
              <ion-icon slot="start" name="add-circle-outline"></ion-icon>
              Új termék
            </ion-button>
          </ng-container>

          <ng-container *ngIf="tab === 'categories'">
            <div class="list-header">
              <span>Kategóriák</span>
              <ion-badge color="light">{{ categories.length }}</ion-badge>
            </div>

            <button
              type="button"
              class="entity-button"
              *ngFor="let category of filteredCategories"
              [class.active]="categoryKey(category) === selectedCategoryKey"
              (click)="selectedCategoryKey = categoryKey(category)"
            >
              <span>
                <strong>{{ category.name }}</strong>
                <small>{{ category.count || 0 }} termék · sorrend: {{ category.sort_order }}</small>
              </span>
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </button>

            <ion-button expand="block" color="tertiary" (click)="addCategory()">
              <ion-icon slot="start" name="add-circle-outline"></ion-icon>
              Új kategória
            </ion-button>
          </ng-container>

          <ng-container *ngIf="tab === 'coupons'">
            <div class="list-header">
              <span>Kuponok</span>
              <ion-badge color="light">{{ coupons.length }}</ion-badge>
            </div>

            <button
              type="button"
              class="entity-button"
              *ngFor="let coupon of filteredCoupons"
              [class.active]="couponKey(coupon) === selectedCouponKey"
              (click)="selectedCouponKey = couponKey(coupon)"
            >
              <span>
                <strong>{{ coupon.name }}</strong>
                <small>{{ coupon.code || 'Nincs kód' }} · {{ couponDiscountLabel(coupon) }} · {{ couponModeLabel(coupon.mode) }}</small>
              </span>
              <ion-badge [color]="coupon.active ? 'success' : 'medium'">{{ coupon.active ? 'aktív' : 'inaktív' }}</ion-badge>
            </button>

            <ion-button expand="block" color="tertiary" (click)="addCoupon()">
              <ion-icon slot="start" name="add-circle-outline"></ion-icon>
              Új kupon
            </ion-button>
          </ng-container>
        </aside>

        <main class="entity-editor">
          <ng-container *ngIf="tab === 'products'">
            <ion-card class="edit-card" *ngIf="selectedProduct as product; else emptyProducts">
              <ion-card-header>
                <div class="edit-head">
                  <div>
                    <ion-card-title>{{ product.name || 'Új termék' }}</ion-card-title>
                    <ion-card-subtitle>Termékadatok, árak, készlet és kategóriák</ion-card-subtitle>
                  </div>
                  <div class="edit-actions">
                    <ion-button fill="clear" size="small" (click)="duplicateProduct(product)">
                      <ion-icon slot="start" name="copy-outline"></ion-icon>
                      Másolás
                    </ion-button>
                    <ion-button fill="clear" size="small" color="danger" (click)="deleteProduct(product)">
                      <ion-icon slot="start" name="trash-outline"></ion-icon>
                      Törlés
                    </ion-button>
                  </div>
                </div>
              </ion-card-header>

              <ion-card-content>
                <div class="form-grid">
                  <ion-input label="Termék neve" label-placement="stacked" fill="outline" [(ngModel)]="product.name"></ion-input>
                  <ion-input label="Angol név" label-placement="stacked" fill="outline" [(ngModel)]="product.name_en"></ion-input>
                  <ion-input label="Cikkszám" label-placement="stacked" fill="outline" [(ngModel)]="product.cikkszam"></ion-input>
                  <ion-input label="Sorrend" type="number" label-placement="stacked" fill="outline" [(ngModel)]="product.sort_order"></ion-input>
                  <ion-input label="Brand" label-placement="stacked" fill="outline" [(ngModel)]="product.brand"></ion-input>
                  <ion-input label="Címkék" label-placement="stacked" fill="outline" placeholder="pl. retinol, érzékeny bőr, újdonság" [(ngModel)]="product.tags"></ion-input>

                  <ion-input label="Normál ár" type="number" label-placement="stacked" fill="outline" [(ngModel)]="product.normal_price"></ion-input>
                  <ion-input label="Akciós ár" type="number" label-placement="stacked" fill="outline" [(ngModel)]="product.discount_price"></ion-input>
                  <ion-input label="Készlet" type="number" label-placement="stacked" fill="outline" [(ngModel)]="product.keszleten"></ion-input>
                  <ion-input label="Alap mennyiség" type="number" label-placement="stacked" fill="outline" [(ngModel)]="product.db"></ion-input>

                  <div class="image-field full">
                    <div class="image-preview" *ngIf="product.pic; else noProductImage">
                      <img [src]="imagePreviewUrl(product.pic)" [alt]="product.name || 'Termékkép'">
                    </div>
                    <ng-template #noProductImage>
                      <div class="image-preview empty">
                        <ion-icon name="image-outline"></ion-icon>
                        <span>Nincs kép feltöltve</span>
                      </div>
                    </ng-template>

                    <div class="image-controls">
                      <ion-input label="Kép URL" label-placement="stacked" fill="outline" [(ngModel)]="product.pic"></ion-input>
                      <label class="upload-button">
                        <input type="file" accept="image/*" (change)="uploadCatalogImage($event, 'product', product)">
                        <ion-icon name="cloud-upload-outline"></ion-icon>
                        <span>{{ isUploadingImage('product', product) ? 'Feltöltés...' : 'Kép tallózása' }}</span>
                      </label>
                      <ion-button fill="clear" size="small" [href]="imagePreviewUrl(product.pic)" target="_blank" [disabled]="!product.pic">
                        <ion-icon slot="start" name="open-outline"></ion-icon>
                        Megnyitás
                      </ion-button>
                    </div>
                  </div>

                  <ion-select
                    class="full"
                    label="Kategóriák"
                    label-placement="stacked"
                    fill="outline"
                    multiple="true"
                    [(ngModel)]="product.categories"
                  >
                    <ion-select-option *ngFor="let category of categories" [value]="categoryKey(category)">
                      {{ category.name }}
                    </ion-select-option>
                  </ion-select>

                  <ion-textarea
                    class="full"
                    label="Leírás"
                    label-placement="stacked"
                    fill="outline"
                    autoGrow="true"
                    [(ngModel)]="product.leiras"
                  ></ion-textarea>

                  <ion-textarea
                    class="full"
                    label="Angol leírás"
                    label-placement="stacked"
                    fill="outline"
                    autoGrow="true"
                    [(ngModel)]="product.leiras_en"
                  ></ion-textarea>
                </div>

                <div class="toggle-row">
                  <ion-toggle [(ngModel)]="product.active">Aktív termék</ion-toggle>
                  <ion-toggle [(ngModel)]="product.vegtelen">Végtelen készlet</ion-toggle>
                  <ion-toggle [(ngModel)]="product.is_vat">Áfás termék</ion-toggle>
                </div>
              </ion-card-content>
            </ion-card>

            <ng-template #emptyProducts>
              <div class="empty-state">
                <ion-icon name="cube-outline"></ion-icon>
                <h2>Még nincs termék</h2>
                <p>Hozz létre egy terméket, majd kategóriához rendelheted és megjelenik a publikus webshopban.</p>
                <ion-button (click)="addProduct()">Első termék létrehozása</ion-button>
              </div>
            </ng-template>
          </ng-container>

          <ng-container *ngIf="tab === 'categories'">
            <ion-card class="edit-card" *ngIf="selectedCategory as category; else emptyCategories">
              <ion-card-header>
                <div class="edit-head">
                  <div>
                    <ion-card-title>{{ category.name || 'Új kategória' }}</ion-card-title>
                    <ion-card-subtitle>Kategória adatok és megjelenés</ion-card-subtitle>
                  </div>
                  <ion-button fill="clear" size="small" color="danger" (click)="deleteCategory(category)">
                    <ion-icon slot="start" name="trash-outline"></ion-icon>
                    Törlés
                  </ion-button>
                </div>
              </ion-card-header>

              <ion-card-content>
                <div class="form-grid">
                  <ion-input label="Kategória neve" label-placement="stacked" fill="outline" [(ngModel)]="category.name"></ion-input>
                  <ion-input label="Angol név" label-placement="stacked" fill="outline" [(ngModel)]="category.name_en"></ion-input>
                  <ion-input label="Sorrend" type="number" label-placement="stacked" fill="outline" [(ngModel)]="category.sort_order"></ion-input>
                  <ion-select label="Szülő kategória" label-placement="stacked" fill="outline" [(ngModel)]="category.parent">
                    <ion-select-option [value]="null">Nincs szülő kategória</ion-select-option>
                    <ion-select-option
                      *ngFor="let parentCategory of categories"
                      [value]="parentCategory.id"
                      [disabled]="!parentCategory.id || parentCategory.id === category.id"
                    >
                      {{ parentCategory.name }}
                    </ion-select-option>
                  </ion-select>
                  <ion-input
                    class="full"
                    label="Főoldali kártya háttér"
                    label-placement="stacked"
                    fill="outline"
                    placeholder="pl. #fff4e6 vagy linear-gradient(135deg, #fff, #f6e6d8)"
                    [(ngModel)]="category.home_background"
                  ></ion-input>
                  <div class="image-field full">
                    <div class="image-preview" *ngIf="category.pic; else noCategoryImage">
                      <img [src]="imagePreviewUrl(category.pic)" [alt]="category.name || 'Kategóriakép'">
                    </div>
                    <ng-template #noCategoryImage>
                      <div class="image-preview empty">
                        <ion-icon name="image-outline"></ion-icon>
                        <span>Nincs kép feltöltve</span>
                      </div>
                    </ng-template>

                    <div class="image-controls">
                      <ion-input label="Kép URL" label-placement="stacked" fill="outline" [(ngModel)]="category.pic"></ion-input>
                      <label class="upload-button">
                        <input type="file" accept="image/*" (change)="uploadCatalogImage($event, 'category', category)">
                        <ion-icon name="cloud-upload-outline"></ion-icon>
                        <span>{{ isUploadingImage('category', category) ? 'Feltöltés...' : 'Kép tallózása' }}</span>
                      </label>
                      <ion-button fill="clear" size="small" [href]="imagePreviewUrl(category.pic)" target="_blank" [disabled]="!category.pic">
                        <ion-icon slot="start" name="open-outline"></ion-icon>
                        Megnyitás
                      </ion-button>
                    </div>
                  </div>
                  <ion-textarea
                    class="full"
                    label="Leírás"
                    label-placement="stacked"
                    fill="outline"
                    autoGrow="true"
                    [(ngModel)]="category.leiras"
                  ></ion-textarea>
                </div>

                <div class="toggle-row">
                  <ion-toggle [(ngModel)]="category.active">Aktív kategória</ion-toggle>
                  <ion-toggle [(ngModel)]="category.home_visible">Főoldalon megjelenik</ion-toggle>
                </div>
              </ion-card-content>
            </ion-card>

            <ng-template #emptyCategories>
              <div class="empty-state">
                <ion-icon name="albums-outline"></ion-icon>
                <h2>Még nincs kategória</h2>
                <p>A kategóriák segítenek a terméklista rendezésében és a nyitóoldali blokkokban is megjelenhetnek.</p>
                <ion-button (click)="addCategory()">Első kategória létrehozása</ion-button>
              </div>
            </ng-template>
          </ng-container>

          <ng-container *ngIf="tab === 'coupons'">
            <ion-card class="edit-card" *ngIf="selectedCoupon as coupon; else emptyCoupons">
              <ion-card-header>
                <div class="edit-head">
                  <div>
                    <ion-card-title>{{ coupon.name || 'Új kupon' }}</ion-card-title>
                    <ion-card-subtitle>Termékekre vagy kategóriákra adható kedvezmény</ion-card-subtitle>
                  </div>
                  <ion-button fill="clear" size="small" color="danger" (click)="deleteCoupon(coupon)">
                    <ion-icon slot="start" name="trash-outline"></ion-icon>
                    Törlés
                  </ion-button>
                </div>
              </ion-card-header>

              <ion-card-content>
                <div class="form-grid">
                  <ion-input label="Kupon neve" label-placement="stacked" fill="outline" [(ngModel)]="coupon.name"></ion-input>
                  <ion-input label="Kupon kódja" label-placement="stacked" fill="outline" [(ngModel)]="coupon.code"></ion-input>

                  <ion-select label="Mire érvényes?" label-placement="stacked" fill="outline" [(ngModel)]="coupon.mode">
                    <ion-select-option value="termek">Termékekre</ion-select-option>
                    <ion-select-option value="kategoria">Kategóriákra</ion-select-option>
                    <ion-select-option value="global">Teljes kosárra</ion-select-option>
                  </ion-select>

                  <ion-select label="Kedvezmény típusa" label-placement="stacked" fill="outline" [(ngModel)]="coupon.discountmode">
                    <ion-select-option value="szazalek">Százalék</ion-select-option>
                    <ion-select-option value="ft">Fix Ft</ion-select-option>
                  </ion-select>

                  <ion-input label="Kedvezmény értéke" type="number" label-placement="stacked" fill="outline" [(ngModel)]="coupon.discountdata"></ion-input>
                  <ion-input label="Érvényesség kezdete" type="date" label-placement="stacked" fill="outline" [(ngModel)]="coupon.kezdo"></ion-input>
                  <ion-input label="Érvényesség vége" type="date" label-placement="stacked" fill="outline" [(ngModel)]="coupon.vege"></ion-input>

                  <ion-select
                    class="full"
                    *ngIf="coupon.mode === 'termek'"
                    label="Érintett termékek"
                    label-placement="stacked"
                    fill="outline"
                    multiple="true"
                    [(ngModel)]="coupon.data"
                  >
                    <ion-select-option *ngFor="let product of products" [value]="product.id + ''" [disabled]="!product.id">
                      {{ product.name }}{{ product.cikkszam ? ' · ' + product.cikkszam : '' }}
                    </ion-select-option>
                  </ion-select>

                  <ion-select
                    class="full"
                    *ngIf="coupon.mode === 'kategoria'"
                    label="Érintett kategóriák"
                    label-placement="stacked"
                    fill="outline"
                    multiple="true"
                    [(ngModel)]="coupon.data"
                  >
                    <ion-select-option *ngFor="let category of categories" [value]="category.id + ''" [disabled]="!category.id">
                      {{ category.name }}
                    </ion-select-option>
                  </ion-select>
                </div>

                <div class="toggle-row">
                  <ion-toggle [(ngModel)]="coupon.active">Aktív kupon</ion-toggle>
                  <ion-note>Ha nincs záró dátum, a kupon visszavonásig érvényes.</ion-note>
                </div>
              </ion-card-content>
            </ion-card>

            <ng-template #emptyCoupons>
              <div class="empty-state">
                <ion-icon name="ticket-outline"></ion-icon>
                <h2>Még nincs kupon</h2>
                <p>Hozz létre kupont termékhez, kategóriához vagy teljes kosárhoz kötött kedvezményhez.</p>
                <ion-button (click)="addCoupon()">Első kupon létrehozása</ion-button>
              </div>
            </ng-template>
          </ng-container>
        </main>
      </div>
    </ion-card-content>
  </ion-card>
</ion-content>
